var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlumniLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 502.67734 181.41733",
    height: 181.41733,
    width: 502.67734,
    id: "svg2",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M 0,136.063 H 377.008 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,181.41733)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.5265,62.0169)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.168 L 15.031,-31.105 H 6.22 l -6.136,15.198 -6.138,-15.198 h -8.81 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.4023,38.3024)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 11.942 V -6.973 H -7.933 V 23.714 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g20"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath26)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.3558,42.518)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-7.014 -4.468,-11.732 -12.693,-11.732 -8.226,0 -12.693,4.718 -12.693,11.732 v 19.499 h 7.933 V 0.544 c 0,-2.964 1.67,-5.051 4.76,-5.051 3.089,0 4.759,2.087 4.759,5.051 V 19.499 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.363,31.3295)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -7.933 v 10.271 l -7.85,-10.815 h -0.334 l -7.891,10.856 V 0 h -7.933 v 31.231 h 0.167 L -15.949,11.274 -0.168,31.231 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(196.4233,47.53)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 14.487 H 7.934 V -16.744 H 7.767 l -17.328,15.03 v -14.487 h -7.933 v 31.232 h 0.167 z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 225.043,31.329 h -7.933 v 30.687 h 7.933 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.3127,73.6395)",
    id: "g42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -0.166 l -14.485,30.962 h 5.686 l 8.882,-19.964 8.882,19.964 h 5.644 z m 25.611,0.456 h -5.188 v 30.505 h 5.188 z m 31.994,25.9 H 47.271 v -25.9 h -5.188 v 25.9 H 31.748 v 4.606 H 57.605 Z M 84.324,0.456 H 78.68 l -2.408,5.52 H 63.49 l -2.408,-5.52 h -5.644 l 14.36,31.046 h 0.166 z m -19.05,9.795 h 9.214 l -4.607,10.584 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.4593,101.8749)",
    id: "g46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -2.739,-4.275 c -1.91,1.578 -4.358,2.74 -7.595,2.74 -3.031,0 -5.064,-1.286 -5.064,-4.068 0,-2.283 1.452,-3.237 6.35,-4.233 7.637,-1.619 10.252,-4.316 10.252,-9.006 0,-5.688 -4.275,-9.506 -11.165,-9.506 -4.607,0 -8.55,1.412 -11.455,3.985 l 2.822,4.317 c 2.117,-2.159 5.562,-3.528 8.799,-3.528 3.528,0 5.811,1.494 5.811,4.275 0,2.241 -1.702,3.445 -6.557,4.441 -7.638,1.66 -10.087,4.482 -10.087,9.007 0,5.395 4.109,9.088 10.335,9.088 C -6.06,3.237 -2.491,1.95 0,0 M 30.295,-1.909 H 19.96 V -27.808 H 14.772 V -1.909 H 4.438 v 4.607 h 25.857 z m 28.24,-15.066 c 0,-6.849 -3.942,-11.373 -11.455,-11.373 -7.553,0 -11.496,4.524 -11.496,11.373 V 2.698 h 5.188 v -19.342 c 0,-4.15 2.117,-6.93 6.308,-6.93 4.151,0 6.267,2.78 6.267,6.93 V 2.698 h 5.188 z m 33.074,4.441 c 0,-9.629 -6.059,-15.274 -16.518,-15.274 H 65.669 V 2.698 h 9.422 c 10.375,0 16.518,-5.603 16.518,-15.232 M 70.857,-2.116 v -20.919 h 4.109 c 7.429,0 11.414,3.86 11.414,10.501 0,6.599 -4.026,10.418 -11.414,10.418 z m 45.858,0.041 h -14.07 v -8.011 h 12.285 v -4.523 h -12.285 v -8.426 h 14.401 v -4.773 H 97.457 V 2.698 h 19.258 z m 30.966,-26.273 h -0.166 l -18.594,19.466 v -18.926 h -5.187 V 3.237 h 0.166 l 18.594,-19.424 V 2.698 h 5.187 z m 31.428,26.439 h -10.335 v -25.899 h -5.188 v 25.899 h -10.334 v 4.607 h 25.857 z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumniLogo);
export default __webpack_public_path__ + "static/media/alumni-logo.76e722a1a8c86aec2aad99c08eafef37.svg";
export { ForwardRef as ReactComponent };